import React from "react";
import { useNavigate } from "react-router-dom";
import "./SubmissionButton.css";

export const SubmissionButton = (props) => {
  const submission = props.props;
  const navigate = useNavigate();

  function handleClick() {
    navigate(submission.url);
  }

  return (
    <a href={submission.url}>
      <button className="submission-button">
        Submit your {submission.title} here
      </button>
    </a>
  );
};
